import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { css } from "styled-components";

Object.assign(addToListModalStyles, {
    modal: {
        size: 450,
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
            `,
        },
    },
});
